// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"a2aa33f2","19":"a1880e57","23":"b9d9b9ec","58":"d2e39c8c","90":"cab193b4","229":"8521cb7f","237":"d4ff4a58","248":"a523e089","378":"8ea9bda2","643":"b13b33e7","819":"6a720a8e","858":"39062072","906":"05ba6646"}[chunkId] + ".chunk.js";
};